import { defineComponent as _defineComponent } from 'vue'
import { useContext, useRouter } from '@nuxtjs/composition-api';
import { computed } from 'vue';
// import { useStore } from '~/store/composable';

interface IStep {
  header: string;
  body: string;
  onClick?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsSteps',
  setup(__props) {

const { i18n } = useContext();
// const {
//   commit,
//   state: { profile },
// } = useStore();
// const router = useRouter();

const heading = computed(() =>
  i18n.t('components.nodes.rewardsSteps.aRewardingExperience'),
);
const body = computed(() =>
  i18n.t('components.nodes.rewardsSteps.itTakesJust'),
);
// const loggedIn = computed(() => profile.user.loggedIn);

const steps = computed<IStep[]>(() => {
  return [
    {
      header: i18n.t('components.nodes.rewardsSteps.1Join') as string,
      body: i18n.t('components.nodes.rewardsSteps.stayUpToDate') as string,
    },
    {
      header: i18n.t('components.nodes.rewardsSteps.2Buy') as string,
      body: i18n.t(
        'components.nodes.rewardsSteps.nodesCanBePurchased',
      ) as string,
      // onClick: () => router.push(`/nodes/film-node/buy`),
    },
    {
      header: i18n.t('components.nodes.rewardsSteps.3Operate') as string,
      body: i18n.t('components.nodes.rewardsSteps.yourGalaFilmNode') as string,
      // onClick: loggedIn.value
      //   ? () => router.push(`/account?settings=my-node`)
      //   : undefined,
    },
    {
      header: i18n.t('components.nodes.rewardsSteps.4Reward') as string,
      body: i18n.t('components.nodes.rewardsSteps.toReceiveRewards') as string,
    },
  ];
});

return { __sfc: true,i18n, heading, body, steps }
}

})